/*
 * Copyright (c) 2011-2019 by Curalate, Inc.
 */

import { PojoSet } from 'pojo-sets';
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getSelectedReelIds = createSelector(
  (state: ICuralateStore) => state.uiaModal.approveForGalleries.gallerySelection,
  (gallerySelection) => {
    return PojoSet.toArray(gallerySelection);
  },
);
